export const TEXT_EDITOR_STYLING_CLASSES = [
  "[&_h1]:text-xl [&_h1]:font-semibold [&_h1]:capitalize [&_h1]:text-primary [&_h1]:my-4",
  "[&_h2]:text-[18px] [&_h2]:font-semibold [&_h2]:text-primary [&_h2]:my-3",
  "[&_h3]:text-lg [&_h3]:font-semibold [&_h3]:leading-[22px] [&_h3]:text-primary [&_h3]:my-2",
  "[&_p]:text-base [&_p]:font-normal [&_p]:leading-[20px] [&_p]:text-primary [&_p]:my-0",
  "[&_ul]:text-primary [&_ol]:text-primary [&_li]:text-primary",
  "[&_ul>li]:list-disc [&_ol>li]:list-decimal [&_ul]:ml-6 [&_ol]:ml-6 [&_li]:ml-0",
  "[&_a]:text-link [&_a]:underline [&_a]:cursor-pointer hover:[&_a]:text-link-hover",
  "[&_strong]:font-semibold [&_em]:italic"
] as const;

export const getTextEditorStylingClasses = (
  additionalClasses: string[] = []
): string[] => {
  return [...TEXT_EDITOR_STYLING_CLASSES, ...additionalClasses];
};
